import actions from './actions';

const {
  ADD_LOGI_BEGIN,
  ADD_LOGI_SUCCESS,
  ADD_LOGI_ERR,

  GET_LOGI_BEGIN,
  GET_LOGI_SUCCESS,
  GET_LOGI_ERR,

  UPDATE_LOGI_BEGIN,
  UPDATE_LOGI_SUCCESS,
  UPDATE_LOGI_ERR,

  DELETE_LOGI_BEGIN,
  DELETE_LOGI_SUCCESS,
  DELETE_LOGI_ERR,
} = actions;

const initialState = {
  data: [],
  loading: false,
  error: null,
};

const LogisticsReducer = (state = initialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case ADD_LOGI_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case ADD_LOGI_SUCCESS:
      return {
        ...state,
        data,
        error: false,
        loading: false,
      };

    case ADD_LOGI_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    case GET_LOGI_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case GET_LOGI_SUCCESS:
      return {
        ...state,
        data,
        error: false,
        loading: false,
      };

    case GET_LOGI_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    case DELETE_LOGI_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case DELETE_LOGI_SUCCESS:
      return {
        ...state,
        error: false,
        data,
        loading: false,
      };

    case DELETE_LOGI_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    case UPDATE_LOGI_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case UPDATE_LOGI_SUCCESS:
      return {
        ...state,
        error: false,
        loading: false,
      };

    case UPDATE_LOGI_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    default:
      return state;
  }
};

export { LogisticsReducer };
